export class DutchAddress {
    public zipcode: string;
    public housenumber: number;
    public housenumbersuffix: string;
    public street: string;
    public city: string;
}
